module.exports = __webpack_public_path__ + "static/img/dots.9793a93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/displacements/dots.jpg
// module id = UNgn
// module chunks = 1